import {actions} from 'mirrorx';

import FileProviders from '../enums/file-providers';

import Dropbox from 'dropbox';
import localforage from 'localforage';
import PromiseFileReader from 'promise-file-reader';

import Pages from '../enums/pages';

class DropboxController {

  constructor(clientId) {
    this.clientId = clientId;
    this.accessToken = null;

    this.isFile = this.isFile.bind(this);
    this.setAccessToken = this.setAccessToken.bind(this);
    this.authenticate = this.authenticate.bind(this);
    this.getPathFromLink = this.getPathFromLink.bind(this);
    this.loadFromDropbox = this.loadFromDropbox.bind(this);
    this.loadFromDropboxLink = this.loadFromDropboxLink.bind(this);
    this.saveToDropbox = this.saveToDropbox.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);

    let self = this;

    window.addEventListener('message',function(e) {
       if (window.location.origin !== e.origin) {
           // Throw error
       } else {
          // e.data Is what was sent from redirectUrl
          // e.data.access_token is the token I needed from dropbox
          console.log(e);
          if (!e.data.access_token) {
            return;
          }

          self.setAccessToken(e.data.access_token);
          localforage.setItem('rune_dropbox_access', self.accessToken).then(() => {
            return localforage.getItem('rune_dropbox_access');
          }).then((item) => {
          });
       }
    },false);

    localforage.getItem('rune_dropbox_access').then(item => {
      if (item) {
        this.setAccessToken(item);
      }
      else {
        actions.layout.setPage(Pages.TUTORIAL);
      }
    });
  }

  authenticate() {
    var dbx = new Dropbox({ clientId: this.clientId });
    var authUrl = dbx.getAuthenticationUrl(window.location.origin + '/redirect');
    window.open(authUrl, 'DropboxAuthPopup', 'dialog=yes,dependent=yes,scrollbars=yes,location=yes');
    // window.location.href = authUrl;
  }

  setAccessToken(token) {
    this.accessToken = token;
    console.log(this.accessToken);
    actions.services.addDropboxAccessToken(token);
  }

  isFile(path, name) {
    if (!this.accessToken) {
      return this.authenticate();
    }
    const dbx = new Dropbox({ 
        accessToken: this.accessToken 
    });

    return dbx.filesGetMetadata({
      path: path+name
    }).then(meta => {
      return new Promise((resolve, reject) => {

        resolve(true);
      });
    }).catch(err => {
      const p = err.error.error.path;
      let exists = true;
      if (p && p['.tag'] === 'not_found') {
        exists = false;
      }

      return new Promise((resolve, reject) => {
        resolve(exists);
      });
    });
  }

  getPathFromLink(link, isDir) {
    if (!this.accessToken) {
      return this.authenticate();
    }
    const dbx = new Dropbox({ 
        accessToken: this.accessToken 
    });
    return dbx.sharingGetSharedLinkMetadata({
      url: link
    }).then(function(meta) {
      return new Promise((resolve, reject) => {
        if (isDir) {
          resolve({
            path: meta.path_lower + '/',
            name: null
          });
        }
        else {
          resolve({
            path: meta.path_lower.replace(/\/[^/]+$/, '') + '/',
            name: meta.name
          });
        }
        
      })
    })
  }

  loadFromDropbox(path, name) {
    if (!this.accessToken) {
      return this.authenticate();
    }
    const dbx = new Dropbox({ 
        accessToken: this.accessToken 
    });

    actions.layout.setFilebarIsOpen(false);
    actions.layout.setIsLoading(true);

    return dbx.filesDownload({
        path: path + name
    }).then(function(data) {
      const blob = data.fileBlob;
      return PromiseFileReader.readAsText(blob);
    }).then(text => {

      actions.editor.updateFileMetadata({
        service: FileProviders.DROPBOX,
        name: name,
        path: path
      });
      actions.editor.updateText(text);
      actions.layout.setIsLoading(false);
      actions.editor.updateDirty(false);
      actions.editor.updateHasBeenSaved(true);
      return Promise.resolve({
        path: path,
        name: name
      });
    }).catch(function(err) {
      // something went wrong.
      // TODO: handle the error
      console.log(err);
      actions.layout.setIsLoading(false);
      return Promise.reject(err);
    });
  }

  loadFromDropboxLink(link) {

    if (!this.accessToken) {
      return this.authenticate();
    }
    
    let self = this;

    return this.getPathFromLink(link, false).then(function(meta) {

      return self.loadFromDropbox(meta.path, meta.name);

    }).catch(err => {
      console.log(err);
      return Promise.reject(err);
    });

  }

  saveToDropbox(contents, path, name) {
    if (!this.accessToken) {
      return this.authenticate();
    }
    const dbx = new Dropbox({
      accessToken: this.accessToken
    });

    return dbx.filesUpload({
      contents: contents,
      path: path + name,
      mode: {
        '.tag': 'overwrite'
      }
    }).then(meta => {
      actions.editor.updateFileMetadata({
        service: FileProviders.DROPBOX,
        name: meta.name,
        path: meta.path_lower.replace(/\/[^/]+$/, '') + '/'
      });
      actions.editor.updateDirty(false);
      actions.editor.updateHasBeenSaved(true);

      return Promise.resolve({
        name: meta.name,
        path: meta.path_lower.replace(/\/[^/]+$/, '') + '/'
      });
    }).catch(err => {
      return Promise.reject(err);
    });
  }

  isAuthenticated() {
    return this.accessToken !== null;
  }
}

export default DropboxController;


// WEBPACK FOOTER //
// ./src/controllers/dropbox-controller.js